<template lang="html">
  <div class="main-down" v-if="el.showDownMsg === 'none'">
    <div class="name">
      {{message.Sl133}}
      <!-- <span class="icon" @click="close">
        &#xe846;
      </span> -->
    </div>
    <div class="box">
      <div class="cell">
        {{message.Al219}}
      </div>
      <div class="cell" style="text-align:center">
        <el-button type="primary"  @click="close">
          {{message.Fl127}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      el: 'el',
      app: 'app'
    })
  },
  data () {
    return {
      message: {
        Sl133: this.$lang.ui.system.l133,
        Fl127: this.$lang.ui.form.l127,
        Al219: this.$lang.ui.app.l219,
        Al154: this.$lang.ui.app.l154,
        Al155: this.$lang.ui.app.l155,
      },
    }
  },
  mounted () {
  },
  methods: {
    close () {
      this.$store.dispatch('downloadMsg', null)
    }
  }
}
</script>

<style lang="css" scoped>
.main-down {
  z-index: 9999;
  position: fixed;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin-left: -200px;
  margin-top: -130px;
  top: 42%;
  left: 50%;
  width: 400px;
  height: auto;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
}
.name {
  position: relative;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0291cf;
}
.name span {
  position: absolute;
  top: 0;
  right: 18px;
  height: 100%;
  display: block;
  color: #fff;
  float: right;
  font-size: 21px;
  cursor: pointer;
}
.name span:hover {
  font-size: 25px;
}
.box {
  width: 100%;
  padding: 20px 40px 14px 40px;
}
.cell {
  width: 100%;
  padding: 12px 0;
  text-align: center;
  overflow: hidden;
}
.download {
  color: #fff;
  text-decoration: none;
}
.cell span {
  display: block;
  cursor: pointer;
  font-size: 12px;
  width: 155px;
  text-align: center;
  color: #0291cf;
}
.left {
  float: left;
}
.right {
  float: right;
}
</style>
